import $ from 'jquery'

export default class Form {
  constructor ($form) {
    this.$form = $form
    this.$controls = $form.find('.form-control')
    this.$submit = $form.find('input[type="submit"], .btn-primary')
    this.$required = $form.find('[required]')

    this.bind()
  }

  bind () {
    let self = this
    this.$controls.on('input', function () {
      const input = $(this)
      const val = input.val()
      const parent = input.closest('.form-group')

      if (val) {
        parent.addClass('form-group_focused')
      } else {
        parent.removeClass('form-group_focused')
      }
    })

    this.$controls.on('blur change', function () {
      const input = $(this)
      const val = input.val()
      const parent = input.closest('.form-group')
      const errorText = input.data('error')

      if (val) {
        parent.addClass('form-group_focused')
      } else if (input.prop('required') && !input.has('.masked')) {
        parent.removeClass('form-group_focused').addClass('form-group_has-error')

        if (errorText) {
          parent.append('<div class="js-error">' + errorText + '</div>')
        }
      }
    })

    this.$controls.on('focus', function () {
      const input = $(this)
      const parent = input.closest('.form-group')

      parent.removeClass('form-group_has-error')
      $('.js-error', parent).remove()
      parent.find('.bottom-hint.hidden').removeClass('hidden')
    })

    this.$required.on('input blur change', () => {
      const length = this.$required.filter(function () {
        return ($(this).val() === null || !$(this).val().length) && $(this).prop('required')
      }).length

      if (length) {
        this.$submit
          .prop('disabled', true)
          .addClass('disabled')
      } else {
        this.$submit
          .prop('disabled', false)
          .removeClass('disabled')
      }
    }).trigger('blur')
  
    this.$form.on('toggleProcessing', () => {
      self.$submit
      .prop('disabled', !self.$submit.prop('disabled'))
      .toggleClass('disabled', !self.$submit.prop('disabled'))
    })
  }
}
